module.exports = __webpack_public_path__ + "img/logo.25bb196d.png";